module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_03a.116095d4.jpg";